<div class="grid">
    <div class="col-12 input-field">
        <label>Tramitador</label>
        <p-dropdown placeholder="Tramitador" [options]="processors" optionLabel="name" optionValue="id" 
            [(ngModel)]="globalFilters.processorId" (onChange)="applyGlobalFilters()" [filter]="true" showClear />
    </div>

    <p-card class="col-12 lg:col-3 xl:col-2" header="Tareas pendientes hoy" *ngIf="loginService.hasPermission('DASHBOARD.WIDGET_TASK_PENDING_TODAY')">
        <div class="card mb-0">
            <div class="flex">
                <div class="text-surface-900 dark:text-surface-0 font-medium text-xl">{{totalTask}}</div>
                <div class="flex-grow-1"></div>
                <i *ngIf="totalTask==0" class="pi pi-check text-green-500"></i>
                <p-button *ngIf="totalTask>0" (click)="goToTasks()" icon="pi pi-reply" [link]="true"></p-button>
            </div>
        </div>
    </p-card>

    <p-card class="col-12 lg:col-3 xl:col-2" header="Expedientes sin compañia" *ngIf="loginService.hasPermission('DASHBOARD.WIDGET_CASES_WITHOUT_COMPANY')">
        <div class="card mb-0">
            <div class="flex">
                <div class="text-surface-900 dark:text-surface-0 font-medium text-xl">{{totalServicesNoCompanyRecords}}
                </div>
                <div class="flex-grow-1"></div>
                <i *ngIf="totalServicesNoCompanyRecords==0" class="pi pi-check text-green-500"></i>
                <a [href]="'cases?withoutCompany=true'" style="text-decoration: none;">
                    <p-button *ngIf="totalServicesNoCompanyRecords>0" icon="pi pi-reply" [link]="true"></p-button>
                </a>
            </div>
        </div>
    </p-card>
    <p-card class="col-12 lg:col-3 xl:col-2" header="Facturas vencen próx. 5 días" *ngIf="loginService.hasPermission('DASHBOARD.WIDGET_DUADATE_NEXT_DAYS')">
        <div class="card mb-0">
            <div class="flex">
                <div class="text-surface-900 dark:text-surface-0 font-medium text-xl">{{totalInvoicesDueSoon}}
                </div>
                <div class="flex-grow-1"></div>
                <i *ngIf="totalInvoicesDueSoon==0" class="pi pi-check text-green-500"></i>
                <a [href]="'transactions/company_outgoing_invoice?notPayed=true'" style="text-decoration: none;">
                    <p-button *ngIf="totalInvoicesDueSoon>0" icon="pi pi-reply" [link]="true"></p-button>
                </a>
            </div>
        </div>
    </p-card>
    <p-card class="col-12 lg:col-3 xl:col-2" header="Obra en curso" *ngIf="loginService.hasPermission('DASHBOARD.WIDGET_WORK_IN_PROGRESS')">
        <div class="card mb-0">
            <div class="flex">
                <div class="text-surface-900 dark:text-surface-0 font-medium text-xl">{{totalServicesWorkInProgressRecords | number: '1.2-2'}}&euro;
                </div>
                <div class="flex-grow-1"></div>
                <i *ngIf="totalServicesWorkInProgressRecords==0" class="pi pi-check text-green-500"></i>
                <a [href]="'cases'" style="text-decoration: none;">
                    <p-button *ngIf="totalServicesWorkInProgressRecords>0" icon="pi pi-reply" [link]="true"></p-button>
                </a>
            </div>
        </div>
    </p-card>
    <p-card class="col-12 lg:col-3 xl:col-2" header="Expedientes sin tramitador" *ngIf="loginService.hasPermission('DASHBOARD.WIDGET_CASES_WITHOUT_PROCESSOR')">
        <div class="card mb-0">
            <div class="flex">
                <div class="text-surface-900 dark:text-surface-0 font-medium text-xl">{{totalServicesNoProcessorRecords}}
                </div>
                <div class="flex-grow-1"></div>
                <i *ngIf="totalServicesNoProcessorRecords==0" class="pi pi-check text-green-500"></i>
                <a [href]="'cases?withoutProcessor=true'" style="text-decoration: none;">
                    <p-button *ngIf="totalServicesNoProcessorRecords>0" icon="pi pi-reply" [link]="true"></p-button>
                </a>
            </div>
        </div>
    </p-card>
    <p-card class="col-12 lg:col-3 xl:col-2" header="Expedientes activos" *ngIf="loginService.hasPermission('DASHBOARD.WIDGET_CASES_ACTIVES')">
        <div class="card mb-0">
            <div class="flex">
                <div class="text-surface-900 dark:text-surface-0 font-medium text-xl">{{totalServicesActiveRecords}}
                </div>
                <div class="flex-grow-1"></div>
                <i *ngIf="totalServicesActiveRecords==0" class="pi pi-check text-green-500"></i>
                <a [href]="'cases?processorId=' + (globalFilters.processorId??this.user.id)" style="text-decoration: none;">
                    <p-button *ngIf="totalServicesActiveRecords>0" icon="pi pi-reply" [link]="true"></p-button>
                </a>
            </div>
        </div>
    </p-card>
    <p-card class="col-12 lg:col-3 xl:col-2" header="Exp. revisión retrasada" *ngIf="loginService.hasPermission('DASHBOARD.WIDGET_CASES_REVIEW_OLD')">
        <div class="card mb-0">
            <div class="flex">
                <div class="text-surface-900 dark:text-surface-0 font-medium text-xl">{{totalServicesReviewOldRecords}}
                </div>
                <div class="flex-grow-1"></div>
                <i *ngIf="totalServicesReviewOldRecords==0" class="pi pi-check text-green-500"></i>
                <a [href]="'cases?processorId=' + (globalFilters.processorId??'') + '&revisionDateTo=' + startOfDay.toISOString()" style="text-decoration: none;">
                    <p-button *ngIf="totalServicesReviewOldRecords>0" icon="pi pi-reply" [link]="true"></p-button>
                </a>
            </div>
        </div>
    </p-card>
    <p-card class="col-12 lg:col-3 xl:col-2" header="Exp. revisión hoy" *ngIf="loginService.hasPermission('DASHBOARD.WIDGET_CASES_REVIEW_TODAY')">
        <div class="card mb-0">
            <div class="flex">
                <div class="text-surface-900 dark:text-surface-0 font-medium text-xl">{{totalServicesReviewTodayRecords}}
                </div>
                <div class="flex-grow-1"></div>
                <i *ngIf="totalServicesReviewTodayRecords==0" class="pi pi-check text-green-500"></i>
                <a [href]="'cases?processorId=' + (globalFilters.processorId??'') + '&revisionDateFrom=' + startOfDay.toISOString() + '&revisionDateTo=' + endOfDay.toISOString()" style="text-decoration: none;">
                    <p-button *ngIf="totalServicesReviewTodayRecords>0" icon="pi pi-reply" [link]="true"></p-button>
                </a>
            </div>
        </div>
    </p-card>
    <p-card class="col-12 lg:col-3 xl:col-2" header="Expedientes sin cita" *ngIf="loginService.hasPermission('DASHBOARD.WIDGET_CASES_NO_CASESERVICES')">
        <div class="card mb-0">
            <div class="flex">
                <div class="text-surface-900 dark:text-surface-0 font-medium text-xl">{{totalServicesNoCasesServices}}
                </div>
                <div class="flex-grow-1"></div>
                <i *ngIf="totalServicesNoCasesServices==0" class="pi pi-check text-green-500"></i>
                <a [href]="'cases?noServices=true'" style="text-decoration: none;">
                    <p-button *ngIf="totalServicesNoCasesServices>0" icon="pi pi-reply" [link]="true"></p-button>
                </a>
            </div>
        </div>
    </p-card>

    <p-card id="ServicesEnded" class="col-12 mt-2 p-card-header-pb-0 p-card-content-pt-0" *ngIf="loginService.hasPermission('DASHBOARD.WIDGET_CASES_SERVICES_TO_REVIEW')">
        <ng-template pTemplate="header">
            <div class="flex align-items-center justify-content-between">
                <div class="p-card-title">Citas pendientes de revisar</div>
                <div class="flex-grow-1"></div>
                <p-button *ngIf="allowAssignProcessor" (click)="assignProcessor(0)" icon="pi pi-user" label="Asignar tramitador" ></p-button>
            </div>
            
        </ng-template>
        <div>
            <p-table #grid [value]="caseServices" [loading]="loadingServices" [paginator]="true" [rows]="20" [lazy]="true"  *ngIf="loadProcessorContractsCalled"
                [totalRecords]="totalServicesRecords" [showCurrentPageReport]="true"  (onLazyLoad)="loadServices($event)"
                currentPageReportTemplate="Mostrando de {first} a {last} de un total de {totalRecords} entradas"
                [rowsPerPageOptions]="[20,50,100]" [scrollable]="true" scrollHeight="flex"
                paginatorDropdownAppendTo="body"  [(selection)]="selectedCases">
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        <th *ngIf="allowAssignProcessor" style="width: 40px;">
                            <p-checkbox
                                [binary]="true"
                                [ngModel]="isAllCaseServicesSelected()"
                                (onChange)="toggleAllCaseServicesSelection($event.checked)">
                            </p-checkbox>
                        </th>
                        <th pSortableColumn="contractId">Contrato <p-sortIcon field="contractId"></p-sortIcon></th>
                        <th>Expediente</th>
                        <th pSortableColumn="processorId">Tramitador <p-sortIcon field="processorId"></p-sortIcon></th>
                        <th>Cliente</th>
                        <th pSortableColumn="date" width="120">Fecha/Hora <p-sortIcon field="date"></p-sortIcon></th>
                        <th pSortableColumn="date" width="120">Fecha Ini/Fin <p-sortIcon field="dateStart"></p-sortIcon></th>
                        <th pSortableColumn="workerId">Operario <p-sortIcon field="workerId"></p-sortIcon></th>
                        <th pSortableColumn="isUrgent" width="80">Urgente <p-sortIcon field="isUrgent"></p-sortIcon>
                        </th>
                        <th pSortableColumn="dateStart" width="120">Estado</th>
                        <th pSortableColumn="dateStart" width="90">Validado</th>
                        <th width="120"></th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-service let-columns="columns">
                    <tr (dblclick)="editCaseService(service)">
                        <td *ngIf="allowAssignProcessor">
                            <p-tableCheckbox [value]="service.caseId"></p-tableCheckbox>
                        </td>
                        <td>
                            <span *ngIf="service.case?.contractId != null">{{service.case?.contract?.code}}</span>
                            <span class="text-danger" *ngIf="service.case?.contractId == null">Sin contrato</span>
                        </td>
                        <td>
                            <a [routerLink]="['/cases', service.case?.id]">{{service.case?.caseNumber}}</a><br>
                            <app-case-service-materials [materials]="service.materials"></app-case-service-materials>
                            <br *ngIf="service.materials?.length">
                            <small>{{service.case?.reference}}<br>{{service.case?.caseDate | date: 'dd/MM/yyyy HH:mm' }}</small>
                        </td>
                        <td>
                            <label [ngClass]="service.case?.processor?.absence ? 'text-danger' : ''">
                            {{(service.case?.processor!=null?service.case?.processor?.name:'Sin definir')}}</label>
                        </td>
                        <td>{{service.case?.client?.name}}</td>
                        <td>{{service.date | date: 'dd/MM/yyyy HH:mm'}}</td>
                        <td><small style="font-size: 11px;">{{service.dateStart | date: 'dd/MM/yyyy HH:mm'}}  {{service.dateEnd | date: 'dd/MM/yyyy HH:mm'}}</small></td>
                        <td>
                            <div>{{service.worker?.name}}</div>
                            <div>
                                <a *ngIf="service.worker?.phone1!=null"
                                    (click)="showPhoneOverlayPanel($event, service.worker?.phone1, service.worker?.name, service.case?.id)">{{service.worker?.phone1}}</a>
                                <a *ngIf="service.worker?.phone2!=null" class="ml-2"
                                    (click)="showPhoneOverlayPanel($event, service.worker?.phone2, service.worker?.name, service.case?.id)">{{service.worker?.phone2}}</a>
                                <a *ngIf="service.worker?.mail!=null"
                                    href="mailto:{{service.worker?.mail}}">{{service.worker?.mail}}</a>
                            </div>
                             <p-overlayPanel #phoneOverlayPanel>
                              <div class=" flex flex-column gap-2">
                                <a (click)="call(phoneOverlayPanelData.phoneNumber, phoneOverlayPanelData.callerId, phoneOverlayPanelData.caseId)">Llamar</a>
                                <a (click)="sms(phoneOverlayPanelData.phoneNumber,  phoneOverlayPanelData.caseId, phoneOverlayPanelData.caseServiceId)">Enviar sms</a>
                                <a (click)="whatsapp(phoneOverlayPanelData.phoneNumber, phoneOverlayPanelData.caseId, phoneOverlayPanelData.callerId)">Enviar whatsapp</a>
                              </div>
                          </p-overlayPanel>
                        </td>
                        <td>
                            <p-tag *ngIf="!service.isUrgent" severity="info" value="Normal" />
                            <p-tag *ngIf="service.isUrgent" severity="danger" value="Urgente" />
                            <p-tag *ngIf="service.isNotScheduled" severity="warn" value="Sin citar" />
                        </td>
                        <!--<td>{{service.dateStart | date: 'dd/MM/yyyy HH:mm'}}</td>
                        <td>{{service.dateEnd | date: 'dd/MM/yyyy HH:mm'}}</td>-->
                        <td>
                            <p-tag *ngIf="service.dateStart==null && service.dateEnd==null" severity="warn"
                                value="Pendiente" />
                            <p-tag *ngIf="service.dateStart!=null && service.dateEnd==null" severity="warn"
                                value="En curso" />
                            <p-tag *ngIf="service.dateEnd!=null" severity="success" value="Finalizado" />
                        </td>
                        <td>
                            <i class="pi"
                                [ngClass]="{ 'text-green-500 pi-check-circle': service.isValidated, 'text-red-500 pi-times-circle': !service.isValidated }"></i>
                        </td>
                        <td>
                            <div class="flex gap-2 justify-content-end">
                                <p-button *ngIf="allowWriteService" (click)="editCaseService(service)" [rounded]="true"
                                    [text]="false"><i class="pi pi-pencil"></i></p-button>
                                <p-button (click)="openChat(service)" [rounded]="true" [text]="false">
                                    <i class="pi pi-comments"></i>
                                </p-button>
                            </div>
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage" let-columns>
                    <tr>
                        <td [attr.colspan]="7">
                            No se han encontrado servicios pendientes
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </p-card>

    <p-card id="LogsRecords" class="col-12 mt-2 p-card-header-pb-0 p-card-content-pt-0" *ngIf="loginService.hasPermission('DASHBOARD.WIDGET_CASES_LOGS_TO_REVIEW')">
        <ng-template pTemplate="header">
            <div class="flex align-items-center justify-content-between">
                <div class="p-card-title">Comunicaciones entrantes de compañía sin revisar</div>
                <div class="flex-grow-1"></div>
                <p-button *ngIf="allowAssignProcessor" (click)="assignProcessor(1)" icon="pi pi-user" label="Asignar tramitador" ></p-button>
            </div>
        </ng-template>
        <div class="flex gap-2 mb-2" style="align-items: center;">
            <p-dropdown [(ngModel)]="caseLogsFilter.caseLogTypeId" [options]="caseLogTypes" optionLabel="name"
                optionValue="id" appendTo="body" placeholder="Seleccione tipo"
                (onChange)="loadLogs(lastGridLogEvent)" showClear styleClass="sm"></p-dropdown>
            <p-dropdown [(ngModel)]="caseLogsFilter.caseCompanyId" [options]="companies" optionLabel="name"
                optionValue="id" appendTo="body" placeholder="Seleccione compañía" (onClear)="caseLogsFilter.caseContractId=null"
                (onChange)="loadLogs(lastGridLogEvent); loadContracts(caseLogsFilter.caseCompanyId)" showClear styleClass="sm"></p-dropdown>
            <p-dropdown [(ngModel)]="caseLogsFilter.caseContractId" [options]="contracts" optionLabel="name"
                optionValue="id" appendTo="body" placeholder="Selecciona contrato"
                (onChange)="loadLogs(lastGridLogEvent)" showClear styleClass="sm"></p-dropdown>            
        </div>
        <div>
            <p-table #grid [value]="caseLogs" [lazy]="true"  [loading]="loadingLogs" *ngIf="loadProcessorContractsCalled" (onLazyLoad)="loadLogs($event)"
                [totalRecords]="totalLogsRecords" [showCurrentPageReport]="true"
                currentPageReportTemplate="Mostrando de {first} a {last} de un total de {totalRecords} entradas"
                [paginator]="true" [rows]="25" [rowsPerPageOptions]="[25,250,500]" [scrollable]="true"
                scrollHeight="flex" paginatorDropdownAppendTo="body" [(selection)]="selectedCases1">
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        <th *ngIf="allowAssignProcessor" style="width: 40px;">
                            <p-checkbox
                                [binary]="true"
                                [ngModel]="isAllCaseLogsSelected()"
                                (onChange)="toggleAllCaseLogsSelection($event.checked)">
                            </p-checkbox>
                        </th>
                        <th width="150">Contrato</th>
                        <th width="180">Expediente</th>
                        <th width="200">Tramitador</th>
                        <th pSortableColumn="log.date" width="180">Fecha <p-sortIcon field="log.date"></p-sortIcon></th>
                        <th>Mensaje </th>
                        <th>Marcar como completado</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-caseLogs let-columns="columns">
                    <tr>
                        <td *ngIf="allowAssignProcessor">
                            <p-tableCheckbox [value]="caseLogs.case?.id"></p-tableCheckbox>
                        </td>

                        <td>
                            <span *ngIf="caseLogs.case?.contractId != null">{{caseLogs.case?.contract?.code}}</span>
                            <span class="text-danger" *ngIf="caseLogs.case?.contractId == null">Sin contrato</span>
                        </td>
                        <td>
                            <a [routerLink]="['/cases', caseLogs.case?.id]">{{caseLogs.case?.caseNumber}}</a><br>
                            <small>{{caseLogs.case?.caseDate | date: 'dd/MM/yyyy HH:mm' }}</small>
                        </td>
                        <td>
                            <label [ngClass]="caseLogs.case?.processor?.absence ? 'text-danger' : ''">
                            {{(caseLogs.case?.processor!=null?caseLogs.case?.processor?.name:'Sin definir')}}</label>
                        </td>
                        <td>
                            <div class="flex gap-2">
                                <div class="event-icon" *ngIf="caseLogs.resourceType==null" pTooltip="Actualización">
                                    <i class="pi pi-info-circle" *ngIf="caseLogs.resourceType==null"></i>
                                </div>
                                <div class="event-icon"
                                    *ngIf="caseLogs.resourceType=='Mail' && caseLogs.direction=='In'"
                                    pTooltip="Email recibido">
                                    <i class="pi pi-envelope"></i>
                                    <i class="pi pi-arrow-down-left top-icon top-icon-red"></i>
                                </div>
                                <div class="event-icon"
                                    *ngIf="caseLogs.resourceType=='Mail' && caseLogs.direction=='Out'"
                                    pTooltip="Email enviado">
                                    <i class="pi pi-envelope"></i>
                                    <i class="pi pi-arrow-up-right top-icon top-icon-green"></i>
                                </div>
                                <div class="event-icon"
                                    *ngIf="caseLogs.resourceType=='Call' && caseLogs.direction=='In'"
                                    pTooltip="Llamada recibida">
                                    <i class="pi pi-phone"></i>
                                    <i class="pi pi-arrow-down-left top-icon top-icon-red"></i>
                                </div>
                                <div class="event-icon"
                                    *ngIf="caseLogs.resourceType=='Call' && caseLogs.direction=='Out'"
                                    pTooltip="Llamada realizada">
                                    <i class="pi pi-phone"></i>
                                    <i class="pi pi-arrow-up-right top-icon top-icon-green"></i>
                                </div>
                                <div class="event-icon"
                                    *ngIf="caseLogs.resourceType=='SMS' && caseLogs.direction=='Out'"
                                    pTooltip="Mensaje enviado">
                                    <i class="pi pi-comment"></i>
                                    <i class="pi pi-arrow-up-right top-icon top-icon-green"></i>
                                </div>
                                <div class="event-icon"
                                    *ngIf="caseLogs.resourceType=='Chat' && caseLogs.direction=='In'"
                                    pTooltip="Chat recibido">
                                    <i class="pi pi-comments"></i>
                                    <i class="pi pi-arrow-down-left top-icon top-icon-red"></i>
                                </div>
                                <div class="event-icon"
                                    *ngIf="caseLogs.resourceType=='Chat' && caseLogs.direction=='Out'"
                                    pTooltip="Chat enviado">
                                    <i class="pi pi-comments"></i>
                                    <i class="pi pi-arrow-up-right top-icon top-icon-green"></i>
                                </div>
                                <div class="event-icon"
                                    *ngIf="caseLogs.resourceType=='Manual' && caseLogs.direction=='Out'"
                                    pTooltip="Evento manual">
                                    <i class="pi  pi-user-edit"></i>
                                    <i class="pi pi-arrow-up-right top-icon top-icon-green"></i>
                                </div>
                                <div>
                                    {{caseLogs.date | date: 'dd/MM/yyyy HH:mm'}}<br>
                                    <small>
                                        <b>
                                            <i class="pi pi-user" style="font-size: 8px"></i>
                                            {{caseLogs.createdByUser.name}}
                                        </b>
                                    </small>
                                </div>
                            </div>
                        </td>
                        <td (dblclick)="showResourceInfoFromLog(caseLogs)">
                            <div class="flex gap-2">
                                <div *ngIf="caseLogs.caseLogTypeId">
                                    <i *ngIf="caseLogs.caseLogType.iconClass" class="pi" [ngClass]="caseLogs.caseLogType.iconClass" pTooltip="{{caseLogs.caseLogType.name}}"></i>
                                </div>
                                <a *ngIf="caseLogs.resourceId != null && (caseLogs.resourceType == 'Mail' || (caseLogs.resourceType == 'Call' && allowRecordingAccess))"
                                    size="small" severity="secondary" pTooltip="Ver mas"
                                    (click)="showResourceInfoFromLog(caseLogs)">
                                    <i *ngIf="!resourceCaseLog[caseLogs.resourceId]" class="pi pi-chevron-right"></i>
                                    <i *ngIf="resourceCaseLog[caseLogs.resourceId]" class="pi pi-chevron-down"></i>
                                </a>
                                <a *ngIf="caseLogs.resourceType == 'AgentSession'" size="small" severity="secondary" pTooltip="Ver capítulos"
                                    (click)="caseLogs.show = !caseLogs.show">
                                    <i *ngIf="!caseLogs.show" class="pi pi-chevron-right"></i>
                                    <i *ngIf="caseLogs.show" class="pi pi-chevron-down"></i>
                                </a>
                                <div *ngIf="caseLogs.resourceType != 'AgentSession'" [innerHtml]="caseLogs.message"></div>
                                <div *ngIf="caseLogs.resourceType == 'AgentSession'"><b>Sesión de agente completada.</b></div>

                            </div>
                            <div *ngIf="caseLogs.resourceType == 'AgentSession' && caseLogs.show" [innerHtml]="caseLogs.message" style="white-space: pre-wrap; margin: 15px;"></div>
                            <div *ngIf="resourceCaseLog[caseLogs.resourceId]" class="mt-2">
                                <p-card *ngIf="caseLogs.resourceType == 'Mail'" [style]="{ 'background-color': '#efefef' }"
                                    styleClass="p-card-content-no-padding p-card-body-no-padding">
                                    <div><b>Desde:</b> {{resourceCaseLog[caseLogs.resourceId].message?.from}}</div>
                                    <div><b>Para:</b> {{resourceCaseLog[caseLogs.resourceId].receipts}}</div>
                                    <div><b>Asunto:</b> {{resourceCaseLog[caseLogs.resourceId].message?.subject}}</div>
                                    <div *ngIf="resourceCaseLog[caseLogs.resourceId].message.attachments.length>0"
                                        class="mt-2 mail-attachments-box">
                                        <div *ngFor="let attachment of resourceCaseLog[caseLogs.resourceId].message.attachments"
                                            class="mr-2">
                                            <a (click)="downloadFile(attachment.fileId)">
                                                <i class="pi pi-file"></i> {{attachment.file?.fileName}}
                                            </a>
                                        </div>
                                    </div>
                                    <div class="mt-2  mail-body-box"
                                        [innerHtml]="getMailBody(resourceCaseLog[caseLogs.resourceId].message)"></div>
                                </p-card>
                                <p-card *ngIf="caseLogs.resourceType == 'Call'" styleClass="p-card-content-no-padding">
                                    <div
                                        *ngIf="resourceCaseLog[caseLogs.resourceId] && resourceCaseLog[caseLogs.resourceId].recording">
                                        <audio controls>
                                            <source
                                                src="{{getRecordingUrl(resourceCaseLog[caseLogs.resourceId].recording)}}"
                                                type="audio/mpeg">
                                            Tu navegador no soporta reproducción de audio
                                        </audio>
                                        <div *ngIf="resourceCaseLog[caseLogs.resourceId].recording?.transcription"
                                            class="mt-4">
                                            <b>Transacción:</b><br>
                                            {{resourceCaseLog[caseLogs.resourceId].recording?.transcription}}
                                        </div>
                                        <div *ngIf="!resourceCaseLog[caseLogs.resourceId].recording?.transcription"
                                            class="mt-4">
                                            Transcripción no disponible
                                        </div>
                                    </div>
                                </p-card>
                            </div>
                        </td> 
                        <td>                            
                            <p-checkbox   
                                [binary]="true"
                                [(ngModel)]="caseLogs.completed" 
                                (onChange)="caseLogCompleted($event, caseLogs)">
                            </p-checkbox >                            
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage" let-columns>
                    <tr>
                        <td [attr.colspan]="4">
                            No se han encontrado comuniaciones entrantes
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </p-card>


    <p-card id="casesIsInitial" class="col-12 p-card-header-pb-0 p-card-content-pt-0" *ngIf="loginService.hasPermission('DASHBOARD.WIDGET_CASES_TO_SCHEDULE')">
        <ng-template pTemplate="header">
            <div class="flex align-items-center justify-content-between">
                <div class="p-card-title">Expedientes sin citar</div>
                <div class="flex-grow-1"></div>
                <p-button *ngIf="allowAssignProcessor" (click)="assignProcessor(2)" icon="pi pi-user" label="Asignar tramitador" ></p-button>
            </div>
        </ng-template>
        <div>
            <p-table styleClass="mt-4" #grid [value]="casesIsInitial" [lazy]="true"
                (onLazyLoad)="loadDataCasesIsInitial($event)" [loading]="loading" [paginator]="true" [rows]="25"
                [totalRecords]="totalcasesIsInitial" [showCurrentPageReport]="true"
                currentPageReportTemplate="Mostrando de {first} a {last} de un total de {totalRecords} entradas"
                [rowsPerPageOptions]="[25,100,250]" [scrollable]="true" scrollHeight="flex"
                paginatorDropdownAppendTo="body" [(selection)]="selectedCases2">
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        <th *ngIf="allowAssignProcessor" style="width: 40px;">
                            <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                        </th>
                        <th pSortableColumn="case.contract.code">Contrato <p-sortIcon field="case.contract.code"></p-sortIcon></th>
                        <th pSortableColumn="caseNumber">Expediente <p-sortIcon field="caseNumber"></p-sortIcon></th>
                        <th pSortableColumn="caseState.name">Estado <p-sortIcon field="caseState.name"></p-sortIcon></th>
                        <th pSortableColumn="caseType.name">Tipo <p-sortIcon field="caseType.name"></p-sortIcon></th>
                        <th pSortableColumn="processor.name">Tramitador <p-sortIcon field="processor.name"></p-sortIcon></th>
                        <th pSortableColumn="caseDate">Fecha <p-sortIcon field="caseDate"></p-sortIcon></th>
                        <th pSortableColumn="caseDate">Días abierto<p-sortIcon field="caseDate"></p-sortIcon></th>
                        <th pSortableColumn="lastActionDate">Días sin actualizar<p-sortIcon field="lastActionDate"></p-sortIcon></th>
                        <th pSortableColumn="revisionDate">Fecha revisión <p-sortIcon field="revisionDate"></p-sortIcon></th>
                        <th pSortableColumn="firstServiceTypeName" width="120">Tipos de servicio <p-sortIcon field="firstServiceTypeName"></p-sortIcon></th>
                        <th pSortableColumn="caseExperts" width="50">Perito <p-sortIcon field="caseExperts"></p-sortIcon></th>
                        <th width="100"></th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-case let-columns="columns">
                    <tr (dblclick)="edit(case)" [pSelectableRow]="case" (mouseenter)="selectedCase=case">
                        <td *ngIf="allowAssignProcessor">
                            <p-tableCheckbox [value]="case"></p-tableCheckbox>
                        </td>
                        <td>
                            <span *ngIf="case.contractId != null">{{case.contract?.code}}</span>
                            <span class="text-danger" *ngIf="case.contractId == null">Sin contrato</span>
                        </td>
                        <td>
                            <div class="flex gap-1">
                                <span [ngStyle]="{'color':case.caseTreatment?.backgroundColor}" [pTooltip]="case.caseTreatment?.name" tooltipPosition="top">
                                    <icon [ngClass]="case.caseTreatment?.icon" style="font-size: 11px;"></icon>
                                </span>
                                <span *ngIf="case.incidentsStatus=='error'" [pTooltip]="'Expediente con incidencias de compañia'" tooltipPosition="top">
                                    <i class="pi pi-exclamation-triangle text-danger" style="font-size: 11px;"></i>
                                </span>
                                <a [routerLink]="['/cases/', case.id]" [pTooltip]="tooltipContent" tooltipPosition="top">{{case.caseNumber}}</a>
                            </div>
                            <div class="flex gap-1">
                                <span *ngIf="case.isRecapture" class="p-tag p-tag-warn">R</span>
                                <span *ngIf="case.isVIP" class="p-tag p-tag-danger">VIP</span>
                                <span *ngIf="case.isUrgent" class="p-tag p-tag-danger">URG</span>
                                <span *ngIf="case.isPrecite" class="p-tag p-tag-danger">Preci</span>
                            </div>
                        </td>
                        <td>
                            <span class="p-tag" [style.backgroundColor]="case.caseState?.backgroundColor"
                                [style.foregroundColor]="case.caseState?.foregroundColor">
                                <span class="p-tag-label">{{case.caseState?.name}}</span>
                            </span>
                        </td>
                        <td>{{(case.caseType!=null?case.caseType?.name:'Sin definir')}}</td>
                        <td>{{(case.processor!=null?case.processor?.name:'Sin definir')}}</td>
                        <td>{{case.caseDate | date: 'dd/MM/yyyy HH:mm:ss'}}</td>
                        <!--<td>{{case.client?.name}}</td>
                        <td>{{case.address?.fullAddress}}</td> -->
                        <td>
                            <div *ngIf="case.recaptureDate==null">{{getTimeAgo(case.caseDate)}}</div>
                            <div *ngIf="case.recaptureDate!=null">{{getTimeAgo(case.recaptureDate)}} ({{getTimeAgo(case.caseDate)}})</div>
                        </td>
                        <td>{{getTimeAgo(case.lastActionDate)}}</td>
                        <td>
                            <span [ngClass]="getRevisionDateClass(case.revisionDate)">
                                {{ case.revisionDate | date: 'dd/MM/yyyy' }}
                            </span>
                        </td>                 
                        <td>
                            <div *ngIf="case.caseServiceTypes.length > 0">
                                <span *ngFor="let caseServiceType of case.caseServiceTypes; let i = index">
                                    <span *ngIf="i>0">, </span>{{caseServiceType.serviceType.name}}
                                </span>
                            </div>
                        </td>       
                        <td>
                            <i class="pi pi-users" *ngIf="case.expertStatus!=null"></i>
                        </td>
                        <td>
                            <div class="flex gap-2 justify-content-end">
                                <p-button *ngIf="allowDeleteService" (click)="delete(case)" [rounded]="true"
                                    [text]="false" severity="danger"><i class="pi pi-trash"></i></p-button>
                                <p-button *ngIf="allowWriteService" (click)="edit(case)" [rounded]="true"
                                    [text]="false"><i class="pi pi-pencil"></i></p-button>
                            </div>
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage" let-columns>
                    <tr>
                        <td [attr.colspan]="11">
                            No se han encontrado servicios sin citar
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </p-card>

</div>

<ng-template #tooltipContent>
    <div *ngIf="selectedCase && selectedCase.client">
        <b>{{selectedCase.client?.name}}</b><br>
        <span *ngIf="selectedCase.address">{{selectedCase.address?.fullAddress}}</span><br>
        <span *ngIf="selectedCase.client?.phone1">{{selectedCase.client?.phone1}}</span> <span *ngIf="selectedCase.client?.phone2">{{selectedCase.client?.phone2}}</span><br>
        <span>Tratamiento: <b>{{selectedCase.caseTreatment?.name}}</b></span>
    </div>
    <div *ngIf="selectedCase && selectedCase.client==null">
        Sin datos de cliente
    </div>
</ng-template>
<p-confirmDialog></p-confirmDialog>

<p-dialog header="Seleccione un tramitador" [(visible)]="displayProcessorModal" [modal]="true" [closable]="false"
    [style]="{width: '400px'}">
    <p-messages severity="info">
        <ng-template pTemplate>
            Se van a cambiar el tramitador a {{selectedCaseIds.length}} expediente{{selectedCaseIds.length>1?'s':''}}.
        </ng-template>
    </p-messages>
        
    <div class="input-field">
        <label for="date">Tramitador</label>
        <p-dropdown [options]="processors" [(ngModel)]="processorId" optionLabel="name" optionValue="id" 
            appendTo="body" [filter]="true" showClear ></p-dropdown>
    </div>

    <ng-template pTemplate="footer">
        <button pButton label="Cancelar" icon="pi pi-times" class="p-button-secondary"
            (click)="displayProcessorModal=false;"></button>
        <button pButton label="Asignar" icon="pi pi-check" (click)="saveProcessor()"></button>
    </ng-template>
</p-dialog>